"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateToQueryString = exports.queryStringMiddleware = exports.createQueryStringReducer = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _get = _interopRequireDefault(require("lodash/get"));
var _set = _interopRequireDefault(require("lodash/set"));
var _validation = require("./validation");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var SERIALIZATION_OPTIONS = {
  allowDots: true,
  arrayFormat: 'repeat'
};
var _pruneNullLeaves = function _pruneNullLeaves(obj) {
  if (!Object.entries(obj).length) {
    return {};
  }
  return Object.assign.apply(Object, _toConsumableArray(Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    if (v === null) {
      return {};
    } else if (Array.isArray(v)) {
      return _defineProperty({}, k, v.filter(function (e) {
        return e !== null;
      }));
    } else if (_typeof(v) === 'object') {
      return _defineProperty({}, k, _pruneNullLeaves(v));
    } else {
      return _defineProperty({}, k, v);
    }
  })));
};
var _applySerialization = function _applySerialization(stateData, map) {
  var result = {};
  Object.entries(map).forEach(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      k = _ref7[0],
      stateField = _ref7[1].stateField;
    result[k] = typeof stateField === 'string' ? (0, _get["default"])(stateData, stateField, null) : stateField.serialize(stateData);
  });
  return result;
};
var stateToQueryString = exports.stateToQueryString = function stateToQueryString(state) {
  for (var _len = arguments.length, maps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    maps[_key - 1] = arguments[_key];
  }
  var serializedState = Object.assign.apply(Object, _toConsumableArray(maps.map(function (map) {
    return _pruneNullLeaves(_applySerialization(state, map));
  })));
  return _qs["default"].stringify(serializedState, SERIALIZATION_OPTIONS);
};
var queryStringMiddleware = exports.queryStringMiddleware = function queryStringMiddleware(history, _ref8) {
  var reduxPathname = _ref8.reduxPathname,
    routes = _ref8.routes;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var usePush = config.usePush;
  return function (store) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var state = store.getState();
        var currentPath = reduxPathname(state);
        var pathConfig = routes[currentPath];
        var routesConfig = pathConfig && !Array.isArray(pathConfig) ? [pathConfig] : pathConfig;
        if (routesConfig && routesConfig.length) {
          var prevData = _qs["default"].parse(history.location.search.slice(1), {
            allowDots: true
          });
          var dataList = routesConfig.filter(function (_ref9) {
            var listen = _ref9.listen;
            return Array.isArray(listen) ? listen.includes(action.type) : listen === action.type;
          }).map(function (_ref10) {
            var select = _ref10.select,
              serialize = _ref10.serialize;
            var qsState = select(state);
            var data = _pruneNullLeaves(qsState);
            if (serialize) {
              data = _applySerialization(data, serialize);
            }
            return data;
          });
          if (dataList.length) {
            var data = Object.assign.apply(Object, _toConsumableArray(dataList));
            data = _pruneNullLeaves(_objectSpread(_objectSpread({}, prevData), data));
            var queryString = _qs["default"].stringify(data, SERIALIZATION_OPTIONS);
            var path = "".concat(currentPath, "?").concat(queryString);
            if (usePush) {
              history.push(path);
            } else {
              history.replace(path);
            }
          }
        }
        return result;
      };
    };
  };
};
var createQueryStringReducer = exports.createQueryStringReducer = function createQueryStringReducer(config, qsFunc) {
  var resetFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (s) {
    return s;
  };
  return function (state, action) {
    var result = qsFunc(state, action);
    if (!result) {
      return resetFunc(state, null);
    }
    var queryString = result.queryString,
      namespace = result.namespace;
    if (queryString) {
      var values = _qs["default"].parse(queryString, {
        allowDots: true
      });
      var newValues = null;
      try {
        newValues = (0, _validation.mapQueryFields)(values, config);
        return (0, _merge["default"])({}, state, namespace ? (0, _set["default"])({}, namespace, newValues) : newValues);
      } catch (e) {
        console.warn(e);
        return resetFunc(state, namespace, true);
      }
    }
    return resetFunc(state, namespace);
  };
};